<template>
	<!-- 短信校验码 -->
    <div class="wkInputPhoneValidate wk-input-box flex">
        <span class="input-left-label">{{label}}</span>
        <div class="flex-jf-btw"  @click="getPhoneCode">
            <input-base type="number" v-model="inputVal" :initVal="value" :placeholder="placeholderOver" maxlength="6" />
			<p class="txtTip" :class="{huoqucode:isHuoQuCode}">
				<template v-if="!isGetPCode">
					<span v-if="!isHuoQuCode" @click="$emit('getPhoneCode')">获取验证码</span> 
					<span v-else class="reget" @click="$emit('getPhoneCode')">重新获取</span> 
				</template>
				<span v-else class="txt-gray"> {{codeTime}}s</span>
			</p>
        </div>
    </div>
</template>
 
<script>
    export default {
        name: 'inputlsit',
		props: ['label', 'placeholder','value','sendType'],
		mounted(){
			this.placeholderOver = this.label;
			if(this.placeholder){
				this.placeholderOver = this.this.placeholder;
            }
            clearInterval(this.timerTmp);
            this.timerTmp = null;
            this.codeTime = 59;
		},
		data(){
			return {
				isGetPCode:false, //-- 是否获得验证码
				isHuoQuCode:false, //-- 是否获过
				placeholderOver:'',
				codeTime:59,
                inputVal:'',
                timerTmp:null
			}
		},
		watch:{
            inputVal(newVal){		 
                if(newVal.length > 6){
                    this.inputVal = newVal.substr(0,6); 
                }
				this.$emit('input',this.inputVal);
            }
        },
		methods:{
			//设置是否获取了验证码
			setIsGetPCode(){
				this.isGetPCode = true;
			},
			//发送短信验证码
			sendPhoneCode(mobilePhone){
                let that = this,obj = {
                    sendType:that.sendType,
                    mobilePhone:mobilePhone,
                    timestamp:Math.round(new Date().getTime()).toString(),
                }
                clearInterval(this.timerTmp);
                this.timerTmp = null;
                this.codeTime = 59;

				//发送手机验证码
				that.$axios_post('other/sms/send',obj).then((res)=>{
					//console.log('短信验证码',res)
					that.isGetPCode = true;
					that.isHuoQuCode = true;	
					if(res.code == '00000000'){
                        clearInterval(that.timerTmp);
                        that.timerTmp = null;
                        that.codeTime = 59;
						that.isHuoQuCode = true;
						//去设置获取验证码的显示
						that.setIsHuoQuGuo();
					}else if(res.code == '90000001'){
                        that.isHuoQuCode = false;
                        that.isGetPCode = false;  
                    }
				});
			},
			//设置是否获取过
			setIsHuoQuGuo(){
				let that = this;
				that.isHuoQuCode = true;
                that.setIsGetPCode();
                clearInterval(that.timerTmp);
                that.timerTmp = null;
                that.codeTime = 59; //恢复初始值
				//手机短信发送成功 ， 并启动定时器
				that.timerTmp = setInterval(()=>{
				    if(that.codeTime > 1){
				        that.codeTime--;
				    }else if(that.codeTime == 1){
				        //清空计时器
                        clearInterval(that.timerTmp);
                        that.timerTmp = null;
				        that.codeTime = 59; //恢复初始值
                        that.isGetPCode = false;
				    }
				},1000)
			},
			//获得当前输入的值
			getPhoneCode(){
				return this.value;
            },
            //校验手机验证码
			validPhoneCode(mobilePhone,phoneCode){ 
				let phoneObj = {
					mobilePhone:mobilePhone,
					verificationCode:phoneCode
				},that = this;
				//发送请求验证 手机验证码
				that.$axios_post('other/sms/validate',phoneObj).then((res)=>{
                    //console.log('校验短信验证码',res)
                    that.isGetPCode = false;
					if(res.code == '00000000'){
                        that.$emit('succFn');
					}else{
                        //错误提示信息
                        that.$store.commit('showErrorInfo',{type:'fail',msg:'短信验证码验证失败'});
                        //调用父级的方法,如果需要做处理
					    that.$emit('failFn');
					}
				})
            }
		}
    }
</script>
<style lang="less" scoped>
    .wkInputPhoneValidate{
		margin-top:.9rem;
		>div{
			// input 输入框
			>p{
				width:10.5rem;
			}
			// 获取验证码
			>p.txtTip{
				width:6.1rem;
				height:2.2rem;
				line-height:1.1rem;
				padding:.45rem 0;
				border:.05rem solid #C12B1C;
				text-align:center;
				font-size:.8rem;
				color: #C12B1C;
                cursor: pointer;
                z-index: 100;
				span{
					padding:.5rem .8rem;;
				}
			}
			>p.huoqucode{
				border:.05rem solid #d1d1d1;
                color:#d1d1d1;
                span.reget{
                    color:#C12B1C;
                }
			}
		}    
    }
</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/wkInputPhoneValidate.vue